import Error from "../../ui/Error";

export default function Top20Position({ data: studentMarks, loggedInUserId }) {
	if (studentMarks === undefined || studentMarks?.length === 0) {
		return <Error message="Sorry! there was an error!" />;
	}

	return (
		<div className="my-8">
			<h3 className="text-lg font-bold">Top 20 Result</h3>
			<table className="text-base w-full border border-slate-600/50 rounded-md my-4">
				<thead>
					<tr className="border-b border-slate-600/50">
						<th className="table-th !text-center">Rank</th>
						<th className="table-th !text-center">Name</th>
						<th className="table-th !text-center">Quiz Mark</th>
						<th className="table-th !text-center">
							Assignment Mark
						</th>
						<th className="table-th !text-center">Total</th>
					</tr>
				</thead>

				<tbody>
					{studentMarks.map((mark) => (
						<tr
							key={mark.id}
							className={
								mark.id === loggedInUserId
									? "border-2"
									: "border-b border-slate-600/50"
							}
						>
							<td className="table-td text-center">
								{mark.rank}
							</td>
							<td className="table-td text-center">
								{mark.name}
							</td>
							<td className="table-td text-center">
								{mark.quizMark}
							</td>
							<td className="table-td text-center">
								{mark.assignmentMark}
							</td>
							<td className="table-td text-center">
								{mark.total}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
